export default {"src":"/_next/static/media/people-green.6a137c92.svg","height":29,"width":29,"blurWidth":0,"blurHeight":0};